/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_IntroInputs */

const cs_settings_office_intro = /** @type {(inputs: Settings_Office_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyto hodnoty platí pro všechny makléře. Osobní kalendáře a Seznam loginy zůstávají na profilu. I malá kancelář používá stejné rozdělení: jedna kancelář, pak vlastní přihlášení do Google.`)
};

const en_settings_office_intro = /** @type {(inputs: Settings_Office_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These values apply to every broker. Personal calendars and Seznam logins stay on each profile. Small offices still use this split: one office record, then your own Google sign-in.`)
};

/**
* | output |
* | --- |
* | "These values apply to every broker. Personal calendars and Seznam logins stay on each profile. Small offices still use this split: one office record, then yo..." |
*
* @param {Settings_Office_IntroInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_intro = /** @type {((inputs?: Settings_Office_IntroInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_IntroInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_intro(inputs)
	return cs_settings_office_intro(inputs)
});